import React from 'react'
const Float = () => {
   return (
      <div className="float">
         <a href="" target="_blank">
            <i className="fas fa-file fa-lg"></i>
            <span>My Resume</span>
         </a>
      </div>
   )
}

export default Float
